function addContinueShoppingBtn() {
  if (window.location.pathname !== '/cart') return;
  if (document.querySelector('.continue-shopping-btn')) return;
  
  var checkoutBtn = document.getElementById('checkout');
  if (checkoutBtn) {
    var btn = document.createElement('a');
    btn.href = '/';
    btn.className = 'btn btn--secondary btn--lg cart-buttons__btn continue-shopping-btn';
    btn.style.cssText = 'display:block; text-align:center; margin-top:12px;';
    btn.textContent = 'お買い物を続ける';
    btn.addEventListener('click', function(e) {
      if (history.length > 1) { e.preventDefault(); history.back(); }
    });
    checkoutBtn.insertAdjacentElement('afterend', btn);
  }
}

document.addEventListener('DOMContentLoaded', addContinueShoppingBtn);
setTimeout(addContinueShoppingBtn, 500);
setTimeout(addContinueShoppingBtn, 1500);
setTimeout(addContinueShoppingBtn, 3000);

document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.video-banner__inner-container video');
  
  videos.forEach(function(video) {
    const container = video.closest('[data-video-banner-container]');
    if (!container) return;
    const poster = container.querySelector('.video-banner__poster');
    if (!poster) return;

    function hidePoster() {
      poster.style.opacity = '0';
      setTimeout(function() {
        poster.style.zIndex = '-1';
      }, 500);
    }

    // 複数のイベントで確実に捕捉
    video.addEventListener('playing', hidePoster);
    video.addEventListener('canplay', function() {
      video.play().then(hidePoster).catch(function() {});
    });

    // フォールバック：2秒後に強制非表示
    setTimeout(hidePoster, 2000);
  });
});

